import { channels } from "@/mocks/chigua";
import SectionHead from "./SectionHead";
import Reveal from "@/components/feature/Reveal";
import { toneIconBg, type Tone } from "./tone";

export default function Channels() {
  return (
    <section id="channels" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-accent-50 to-transparent"></div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHead
            kicker="官方渠道 · ENTRANCE"
            title="官方服务入口"
            subtitle="下载、客服、反馈、合作与安全指南等官方渠道集中收纳,认准官方入口,远离仿冒。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((ch, idx) => (
            <Reveal key={ch.title} delay={(idx % 3) * 80}>
              <a
                href="#channels"
                className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-100 p-4 transition-all hover:-translate-y-1 hover:border-accent-200 hover:bg-background-50 md:p-5"
              >
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-2xl ${toneIconBg[ch.tone as Tone]}`}>
                  <i className={ch.icon}></i>
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="flex items-center gap-1.5 text-base font-bold text-foreground-950">
                    {ch.title}
                    <i className="ri-external-link-line text-sm text-foreground-300 transition-all group-hover:text-accent-600"></i>
                  </h3>
                  <p className="mt-0.5 truncate text-sm text-foreground-500">{ch.desc}</p>
                </div>
                <i className="ri-arrow-right-s-line text-2xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-accent-600"></i>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}